export const MAX_PREVIEW_GOALS_AMOUNT = 2;
